import AbortController from "abort-controller";

class CustomAborter {

    constructor() {
    }

    static signal(timeout) {
        const controller = new AbortController();
        const signal = controller.signal;
        setTimeout(() => {
            controller.abort();
        }, timeout);
        return signal;
    }
}

export default CustomAborter;